import { request } from '../request'

// 01 客户端列表
export const getTargetList = () => request('/portal/verify/endpointSecurity/targetList')

//获取att&ck列表
export const getAttCkList = () => request('/portal/verify/endpointSecurity/attCkList')

//获取全局参数
export const getGlobalParam = () => request('/portal/verify/endpointSecurity/getGlobalParam')

// 修改全局参数
export interface UpdateGlobalParam {
  param: {
    key: string
    description: string
    default: string
    type: string
    value: string
    is_permanent: number
    file_path?: string
  }[]
}
export const updateGlobalParam = (data: UpdateGlobalParam) =>
  request('/portal/verify/endpointSecurity/updateGlobalParam', {
    method: 'put',
    data,
  })

// 获取模板列表
export interface GetTemplateList {
  keyword?: string
}
export const getTemplateList = (data: GetTemplateList) =>
  request('/portal/verify/endpointSecurity/templateList', { params: data })

// 获取插件列表
export interface GetPluginList {
  keyword?: string
  risk_level?: string
  attack_type?: string
  depend_envs?: string
  supported_platforms?: string
  os_system?: number | null
  template_ids: string
  page?: number
  limit?: number
  tag_ids?: string[]
}
export const getPluginList = (data: GetPluginList) =>
  request('/portal/verify/endpointSecurity/pluginList', { params: data })

// 插件详情
export interface GetPluginDetail {
  resource_id: string
}
export const getPluginDetail = (data: GetPluginDetail) =>
  request('/portal/verify/endpointSecurity/pluginDetail', { params: data })

//  修改插件参数
export interface UpdatePluginDetail {
  plugin_id: string
  param: {
    key: string
    description: string
    default: string
    type: string
    value: string
    is_permanent: number
  }[]
}
export const updatePluginDetail = (data: UpdatePluginDetail) =>
  request('/portal/verify/endpointSecurity/updatePluginDetail', { method: 'put', data })

//  创建任务
export interface PostCreateTask {
  name?: string
  schedulerType?: string
  resourceIds?: string[]
  templateList?: { id: string; useLatestResource: boolean }[]
  groupId?: string
  verificationType?: string
  executionTimes?: number
  reduceSpeed?: number
  priority?: number
  os?: string
  arch?: string
  deviceIds?: string[]
  cronSchedule?: {
    timeOfDay?: string
    dayOfWeek?: string
    dayOfMonth?: string
  }
  reportConfig?: {
    send?: boolean
    emailList?: { id: string; name: string; email: string }[]
    filter?: boolean
    condition?: string[]
  }
  agentToHost?: {
    agentId?: string
    hostId?: string
  }
  agentToListener?: {
    agentId?: string
    hostId?: string
    nat?: boolean
    dport?: number
    dnatIp?: string
    dnatPort?: number
  }
}
export const postCreateTask = (data: PostCreateTask) =>
  request('/portal/verify/endpointSecurity/createTask', { method: 'post', data })

export const getAttackTypeList = () =>
  request('/portal/verify/endpointSecurity/createTaskAttackTypeList')

// 安全设备
export const getDevices = () => request('/portal/verify/endpointSecurity/devices')

//  插件数量（攻击类型&&依赖环境）
export interface GetPluginAmounts {
  template_ids: string
}
export const getPluginAmounts = (params: GetPluginAmounts) =>
  request('/portal/verify/endpointSecurity/pluginAmounts', {
    params,
  })

//  插件数量（攻击类型&&依赖环境）
export interface GetDownloadDependEnvs {
  depend_env: string
}
export const getDownloadDependEnvs = (params: GetDownloadDependEnvs) =>
  request('/portal/verify/endpointSecurity/downloadDependEnvs', {
    params,
    // responseType: 'arraybuffer',
  })

// 获取listener安装命令
export const getListenerInstallCmd = () =>
  request('/portal/v1/endpoint_security/listener/install_command')

// 获取反弹shell参数
export const getReverseShellParam = () =>
  request('/portal/v1/endpoint_security/reverse_shell/global_param')

// 获取自动监听listener ip
export const getAutoListenerIp = () =>
  request('/portal/v1/endpoint_security/auto_listener_evil_host')

// 更新反弹shell参数
export const updateReverseShellParam = (data: any) =>
  request('/portal/v1/endpoint_security/reverse_shell/global_param', {
    method: 'put',
    data,
  })

// 树结构标签选项
export const getTagTreeOptions = data =>
  request(`/portal/v1/endpoint_security/bind_tag_list`, {
    params: {
      ...data,
    },
  })

// 获取agent列表
export const getAgentList = (params?: { os?: string[]; arch?: string[] }) =>
  request('/portal/v1/task/agent_list', { params })

// 获取主机列表
export const getHostList = () => request('/portal/v1/task/host_list')

// 根据hostId获取设备列表
export const getDeviceListByHostId = (id?: string) =>
  request(`/portal/v1/es/host/${id}/device`, { params: { scene: 'SCENEID_ENDPOINTSECURE' } })

// 添加用例模板
export const addCaseTemplate = (data: { name: string; resourceIds: string[] }) =>
  request('/portal/common/resourceTemplate', { method: 'post', data })

// 获取用例模板列表
export interface GetCaseTemplateList {
  page?: number
  pageSize?: number
  filterParams?: {
    name?: string
    sortOrder?: string
    sortField?: string
    verificationModeIds?: number[]
    sceneIds?: number[]
  }
  os?: string
}
export const getCaseTemplateList = (data: GetCaseTemplateList) =>
  request('/portal/common/resourceTemplates', { method: 'post', data })

// 获取用例模板列表筛选的全量模板ids
export const getCaseTemplateIdsAll = (data?: GetCaseTemplateList) =>
  request('/portal/common/resourceTemplates/ids', {
    method: 'post',
    data,
  })

// 获取模板关联/未关联用例列表
export interface GetUsCaseList {
  templateId: string[]
  page?: number
  pageSize?: number
  queryType: string
  filterParams?: {
    name?: string
    deviceType?: string
    riskLevel?: string
    resourceLevel?: string
    attackTypeId?: string
    tagId?: string
    sortOrder?: string
    sortField?: string
    verificationModeId?: number[]
    sceneId?: number[]
  }
}
export const getUsCaseList = (data: GetUsCaseList) =>
  request('/portal/common/resourceTemplate/resources', { method: 'post', data })

// 根据筛选条件获取模板关联/未关联用例ids
export const getUsCaseIdsAll = (data: GetUsCaseList) =>
  request('/portal/common/resourceTemplate/filter/ResourceIds', { method: 'post', data })

// 获取用例详情
export const getCaseDetail = (id: string) => request(`/portal/common/es/resource/${id}`)

// 查询人员邮箱列表
export const getUserEmailList = () => request('/portal/common/email_users')

// 获取任务基础信息（任务复制）
export const getTaskBaseInfo = (id: string) => request(`/portal/v1/endpoint_security/tasks/${id}`)

// 修改用例详情-自定义参数修改
export const updateCaseDetail = data =>
  request('/portal/verify/endpointSecurity/updatePluginDetail', { method: 'put', data })

// 样本文件下载
export const getSampleFile = (data: { resourceId: string; sha256: string }) =>
  request(`/portal/verify/endpointSecurity/plugin/${data.resourceId}/sample/${data.sha256}`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/octet-stream',
      Accept: 'application/octet-stream',
    },
    responseType: 'blob',
  })

// 获取攻击类型列表
export const filterAttackTypeList = data =>
  request('/portal/common/attack/attack_type_filter_list', { params: data })
